import type React from "react";

interface EmptyWalletIconProps {
	size?: number;
	className?: string;
}

export const EmptyWalletIcon: React.FC<EmptyWalletIconProps> = ({
	size = 120,
	className = "",
}) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 120 120"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		aria-hidden="true"
	>
		{/* Wallet outline */}
		<rect
			x="20"
			y="30"
			width="80"
			height="60"
			rx="8"
			stroke="#9CA3AF"
			strokeWidth="2.5"
			fill="#F3F4F6"
		/>

		{/* Wallet flap */}
		<path
			d="M 20 45 L 30 35 L 90 35 L 100 45"
			stroke="#9CA3AF"
			strokeWidth="2.5"
			fill="#E5E7EB"
		/>

		{/* Card slot */}
		<rect
			x="30"
			y="55"
			width="40"
			height="25"
			rx="4"
			stroke="#D1D5DB"
			strokeWidth="2"
			fill="white"
			strokeDasharray="4 4"
		/>

		{/* Plus icon in center */}
		<circle cx="60" cy="67.5" r="18" fill="#4C63B6" opacity="0.1" />
		<path
			d="M 60 60 L 60 75 M 52.5 67.5 L 67.5 67.5"
			stroke="#4C63B6"
			strokeWidth="2.5"
			strokeLinecap="round"
		/>
	</svg>
);
